import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;


/* =========================================================
   FACEBOOK PAGE LINKS
   Replace these two links with your actual Facebook pages
   ========================================================= */

const gnssFacebookPage =
  'https://www.facebook.com/GNSSResearchLab/';

const gserlFacebookPage =
  'https://www.facebook.com/SpaceOutreach/';


/* =========================================================
   SOCIAL FEED COMPONENT
   ========================================================= */

const SocialFeed = () => {
  return (
    <section className="lab-social-section">

      <div className="lab-social-inner">

        {/* Section Heading */}

        <Title
          level={2}
          className="lab-social-title"
        >
          Social Feed
        </Title>

        <Divider className="ncgsa-divider" />


        {/* =================================================
            TWO FACEBOOK FEEDS
            ================================================= */}

        <div className="lab-social-grid">


          {/* =========================
              GNSS
              ========================= */}

          <div className="lab-social-column">

            <Title
              level={4}
              className="lab-social-feed-title"
            >
              GNSS Research Lab
            </Title>

            <div className="lab-facebook-frame-wrap">

             <iframe
  title="GNSS Research Lab Facebook Feed"
  src={
    "https://www.facebook.com/plugins/page.php?" +
    "href=https%3A%2F%2Fwww.facebook.com%2FGNSSResearchLab%2F" +
    "&tabs=timeline" +
    "&width=500" +
    "&height=620" +
    "&small_header=false" +
    "&adapt_container_width=true" +
    "&hide_cover=false" +
    "&show_facepile=true"
  }
  className="lab-facebook-frame"
  width="500"
  height="620"
  scrolling="no"
  frameBorder="0"
  allowFullScreen={true}
  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
/>

            </div>

            <a
              href={gnssFacebookPage}
              target="_blank"
              rel="noopener noreferrer"
              className="lab-facebook-fallback"
            >
              View GNSS Research Lab on Facebook
            </a>

          </div>


          {/* =========================
              GSERL
              ========================= */}

          <div className="lab-social-column">

            <Title
              level={4}
              className="lab-social-feed-title"
            >
             Space Education Research Lab
            </Title>

            <div className="lab-facebook-frame-wrap">

             <iframe
  title="GNSS and Space Education Research Lab Facebook Feed"
  src={
    "https://www.facebook.com/plugins/page.php?" +
    "href=https%3A%2F%2Fwww.facebook.com%2FSpaceOutreach%2F" +
    "&tabs=timeline" +
    "&width=500" +
    "&height=620" +
    "&small_header=false" +
    "&adapt_container_width=true" +
    "&hide_cover=false" +
    "&show_facepile=true"
  }
  className="lab-facebook-frame"
  width="500"
  height="620"
  scrolling="no"
  frameBorder="0"
  allowFullScreen={true}
  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
/>

            </div>

            <a
              href={gserlFacebookPage}
              target="_blank"
              rel="noopener noreferrer"
              className="lab-facebook-fallback"
            >
              View GSERL on Facebook
            </a>

          </div>

        </div>

      </div>

    </section>
  );
};


export default SocialFeed;
